import { ChangeEvent, FC } from 'react';
import { Switch as MSwitch } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  onChecked?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label: string;
  checked?: boolean;
  labelPosition?: 'left' | 'right';
}

const Switch: FC<Props> = ({ label, className, onChecked, checked, labelPosition, ...others }): JSX.Element => {
  return (
    <MSwitch
      checked={checked}
      onChange={onChecked}
      label={label}
      role={'switch'}
      labelPosition={labelPosition}
      className={classNames(styles.switch, className)}
      {...others}
    />
  );
};

export default Switch;
